import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip';

export const Tooltips = () => {
    return (
        <React.Fragment>
				<ReactTooltip id='history' type='info'>
					<span>Nhật kí giao dịch</span>
				</ReactTooltip>
                <ReactTooltip id='quickpay' type='info'>
					<span>QuickPay</span>
				</ReactTooltip>
				<ReactTooltip id='pendingtrans' type='info'>
					<span>GD chờ xác nhận</span>
				</ReactTooltip>
				<ReactTooltip id='setting' type='info'>
					<span>Cài đặt</span>
				</ReactTooltip>
        </React.Fragment>
    );
}